import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTrophy } from 'react-icons/fa';
import * as FaIcons from 'react-icons/fa';

const AchievementNotification = ({ achievement, onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const hasCompletedRef = useRef(false);

  useEffect(() => {
    if (!achievement) return;

    // 重置完成狀態
    hasCompletedRef.current = false;

    // 2秒後開始淡出
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 2000);

    // 2.8秒後調用 onComplete (確保動畫完全完成)
    const completeTimer = setTimeout(() => {
      if (!hasCompletedRef.current && onComplete) {
        hasCompletedRef.current = true;
        onComplete();
      }
    }, 2800);

    return () => {
      clearTimeout(hideTimer);
      clearTimeout(completeTimer);
    };
  }, [achievement, onComplete]);

  // 當動畫退出完成時也調用 onComplete (作為備用)
  const handleExitComplete = () => {
    if (!hasCompletedRef.current && onComplete) {
      hasCompletedRef.current = true;
      onComplete();
    }
  };

  if (!achievement) {
    return null;
  }

  const Icon = FaIcons[achievement.icon];

  return (
    <div className="fixed top-16 sm:top-20 left-0 w-full flex justify-center pointer-events-none z-[90]">
      <AnimatePresence mode="wait" onExitComplete={handleExitComplete}>
        {isVisible && (
          <motion.div
            key={achievement.id}
            initial={{ opacity: 0, scale: 0.5, y: -50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.5, y: -50 }}
            transition={{
              type: 'spring',
              damping: 20,
              stiffness: 300,
              exit: { duration: 0.3 }
            }}
            className="max-w-xs w-[85%] sm:max-w-sm sm:w-[90%]"
          >
            <div className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-orange-500 text-white px-4 py-2.5 sm:px-6 sm:py-4 rounded-xl sm:rounded-2xl shadow-2xl flex items-center gap-2.5 sm:gap-4 border-2 sm:border-4 border-white">
              <div className="w-10 h-10 sm:w-14 sm:h-14 bg-white/20 rounded-full flex items-center justify-center animate-pulse flex-shrink-0">
                <FaTrophy size={20} className="sm:w-7 sm:h-7" />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="text-[10px] sm:text-xs font-bold uppercase tracking-wide opacity-90 mb-0.5 sm:mb-1">
                  🎉 新成就!
                </div>
                <div className="font-bold text-sm sm:text-lg flex items-center gap-1.5 sm:gap-2">
                  {Icon && <Icon size={14} className="sm:w-[18px] sm:h-[18px]" />}
                  <span className="truncate">{achievement.name}</span>
                </div>
                <div className="text-[10px] sm:text-xs opacity-90 mt-0.5 sm:mt-1 line-clamp-1 sm:line-clamp-2">
                  {achievement.description}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AchievementNotification;